import { getStoryblokApi } from '@storyblok/react'
import { ImpressionStory } from './types'

export async function fetchImpressions(preview?: boolean): Promise<ImpressionStory[]> {
  const storyblok = getStoryblokApi()

  const { data } = await storyblok.get(`cdn/stories`, {
    version: preview ? 'draft' : 'published',
    resolve_links: 'story',
    starts_with: 'impressionen/',
    is_startpage: false,
    sort_by: 'published_at:desc',
    per_page: 10,
  })

  return data.stories
}
